import api from './api.service';
import { CandidateDetail, CandidateFile, AcceptCandidateRequest } from '../types/candidat';

class CandidatsService {
  async listForColoc(colocId: string): Promise<CandidateDetail[]> {
    const response = await api.get(`/enrollment-candidates/coloc/${colocId}`);
    return response.data;
  }

  async getFiles(candidateId: string): Promise<CandidateFile[]> {
    const response = await api.get(`/enrollment-candidates/${candidateId}/enrollment-form-files`);
    return response.data;
  }

  async accept(candidateId: string, data: AcceptCandidateRequest): Promise<unknown> {
    const response = await api.post(`/enrollment-candidates/${candidateId}/accept`, data);
    return response.data;
  }

  async reject(candidateId: string, sendEmail: boolean): Promise<unknown> {
    const response = await api.post(
      `/enrollment-candidates/${candidateId}/reject`,
      null,
      { params: { send_email: sendEmail } }
    );
    return response.data;
  }

  async remove(candidateId: string): Promise<unknown> {
    const response = await api.delete(`/enrollment-candidates/${candidateId}`);
    return response.data;
  }

  async reopen(candidateId: string): Promise<unknown> {
    const response = await api.post(`/enrollment-candidates/${candidateId}/reopen`);
    return response.data;
  }

  async downloadFile(candidateId: string, fileId: string): Promise<Blob> {
    const response = await api.get(
      `/enrollment-candidates/${candidateId}/files/${fileId}/download`,
      { responseType: 'blob' }
    );
    return response.data;
  }

  async downloadArchive(candidateId: string): Promise<Blob> {
    const response = await api.get(
      `/enrollment-candidates/${candidateId}/files/archive`,
      { responseType: 'blob' }
    );
    return response.data;
  }
}

export const candidatsService = new CandidatsService();
